"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var NewSalesDashboardReportRow_1 = require("../model/NewSalesDashboardReportRow");

var NewSalesDashboardReportRowConverter_1 = require("./NewSalesDashboardReportRowConverter");

var utils_1 = require("../../core/utils");

var NewSalesDashboardReportRowConverterImpl =
/*#__PURE__*/
function (_NewSalesDashboardRep) {
  _inherits(NewSalesDashboardReportRowConverterImpl, _NewSalesDashboardRep);

  function NewSalesDashboardReportRowConverterImpl() {
    _classCallCheck(this, NewSalesDashboardReportRowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewSalesDashboardReportRowConverterImpl).apply(this, arguments));
  }

  _createClass(NewSalesDashboardReportRowConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NewSalesDashboardReportRow_1.NewSalesDashboardReportRow(NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.id.valueOf(conversions.documentToClassId(source)), NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.reportId.valueOfField(source), //
      NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.level.valueOfField(source), NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.entity.valueOfField(source), NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.entityId.valueOf(source.entityId ? conversions.toClassReferenceId(source.entityId) : null), NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.isGroup.valueOfField(source), NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.title.valueOfField(source), NewSalesDashboardReportRow_1.NewSalesDashboardReportRow.schema.titleData.valueOfField(source), //
      source.regularKpiValues ? this.kpiToObj(source.regularKpiValues, conversions) : null, source.regularKpiValuesDeltas ? this.kpiToObj(source.regularKpiValuesDeltas, conversions) : null, source.leafletKpiValues ? this.kpiToObj(source.leafletKpiValues, conversions) : null, source.leafletKpiValuesDeltas ? this.kpiToObj(source.leafletKpiValuesDeltas, conversions) : null, source.nonLeafletKpiValues ? this.kpiToObj(source.nonLeafletKpiValues, conversions) : null, source.nonLeafletKpiValuesDeltas ? this.kpiToObj(source.nonLeafletKpiValuesDeltas, conversions) : null, source.totalKpiValues ? this.kpiToObj(source.totalKpiValues, conversions) : null, source.totalKpiValuesDeltas ? this.kpiToObj(source.totalKpiValuesDeltas, conversions) : null, source.regNonLeafletKpiValues ? this.kpiToObj(source.regNonLeafletKpiValues, conversions) : null, source.regNonLeafletKpiValuesDeltas ? this.kpiToObj(source.regNonLeafletKpiValuesDeltas, conversions) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = conversions.classToDocumentId(source);
      Object.assign(result, {
        reportId: source.reportId,
        level: source.level,
        entity: source.entity,
        entityId: source.entityId ? conversions.toDocumentReferenceId(source.entityId) : null,
        isGroup: source.isGroup,
        title: source.title,
        titleData: source.titleData,
        regularKpiValues: source.regularKpiValues ? this.kpiToDoc(source.regularKpiValues, conversions) : null,
        regularKpiValuesDeltas: source.regularKpiValuesDeltas ? this.kpiToDoc(source.regularKpiValuesDeltas, conversions) : null,
        leafletKpiValues: source.leafletKpiValues ? this.kpiToDoc(source.leafletKpiValues, conversions) : null,
        leafletKpiValuesDeltas: source.leafletKpiValuesDeltas ? this.kpiToDoc(source.leafletKpiValuesDeltas, conversions) : null,
        nonLeafletKpiValues: source.nonLeafletKpiValues ? this.kpiToDoc(source.nonLeafletKpiValues, conversions) : null,
        nonLeafletKpiValuesDeltas: source.nonLeafletKpiValuesDeltas ? this.kpiToDoc(source.nonLeafletKpiValuesDeltas, conversions) : null,
        totalKpiValues: source.totalKpiValues ? this.kpiToDoc(source.totalKpiValues, conversions) : null,
        totalKpiValuesDeltas: source.totalKpiValuesDeltas ? this.kpiToDoc(source.totalKpiValuesDeltas, conversions) : null,
        regNonLeafletKpiValues: source.regNonLeafletKpiValues ? this.kpiToDoc(source.regNonLeafletKpiValues, conversions) : null,
        regNonLeafletKpiValuesDeltas: source.regNonLeafletKpiValuesDeltas ? this.kpiToDoc(source.regNonLeafletKpiValuesDeltas, conversions) : null
      });
      return result;
    }
  }, {
    key: "kpiToDoc",
    value: function kpiToDoc(source, conversions) {
      return source.map(function (a) {
        return conversions.fromBigNumber(a);
      }).toObject();
    }
  }, {
    key: "kpiToObj",
    value: function kpiToObj(source, conversions) {
      var map = immutable_1.Map();
      Object.keys(source).forEach(function (key) {
        if (!utils_1.Utils.isValueMissing(source[key])) {
          map = map.set(key, conversions.toBigNumber(source[key]));
        }
      });
      return map.size ? map : null;
    }
  }]);

  return NewSalesDashboardReportRowConverterImpl;
}(NewSalesDashboardReportRowConverter_1.NewSalesDashboardReportRowConverter);

exports.NewSalesDashboardReportRowConverterImpl = NewSalesDashboardReportRowConverterImpl;